module.exports = __webpack_public_path__ + "img/banner.bd60ee80.jpg";